import {CrawlTrackerService} from "../services/sp-crawl-tracker/crawl-tracker.service";
import {Crawl} from "./crawl";

export type ProjectCrawlStatus = 'in_progress' | 'done' | 'unknown';

export class CrawlStatus {
  name: string;
  crawlId: string;
  lastUpdate: number;
  size: number;
  state: string;
  progress: number;
  startedAt: number;
  actualStep: number;
  steps: number;
  progression: boolean;
  loadingStatus: string;
  universeIds: number[];

  static done(): CrawlStatus {
    const done = new CrawlStatus();
    done.universeIds = [];
    done.state = "done";
    done.loadingStatus = "Done !";
    done.progression = false;
    done.actualStep = CrawlTrackerService.STEP_PERSONAE + 1;
    return done;
  }

  static fromCrawl(crawl: Crawl | null): CrawlStatus {
    if (!crawl || CrawlStatus.isCrawlDone(crawl)) return CrawlStatus.done();

    const inProgress = new CrawlStatus();
    inProgress.universeIds = [];
    inProgress.state = "crawling";
    inProgress.loadingStatus = "Crawling...";
    inProgress.progression = true;
    inProgress.size = 0;
    inProgress.progress = 0;
    inProgress.steps = CrawlTrackerService.STEP_PERSONAE;
    inProgress.actualStep = crawl.criteria_ready ? CrawlTrackerService.STEP_PERSONAE : 1;
    return inProgress;
  }

  static isCrawlDone(crawl: Crawl): boolean {
    return !!crawl.criteria_ready && !crawl.segment_crawling;
  }

  static unavailable(): CrawlStatus {
    const unavailable = new CrawlStatus();
    unavailable.state = "unavailable";
    unavailable.loadingStatus = "Unavailable...";
    unavailable.progression = false;
    unavailable.actualStep = 0;
    return unavailable;
  }
}
